<section class="tunings-preview" [attr.aria-label]="'Matched tunings for Pure Original ' + pureOriginalId" [attr.aria-busy]="loading()">
    @if (loading()) {
        <div class="preview-state" role="status"><i class="bi bi-arrow-repeat loading-icon" aria-hidden="true"></i>Loading matched tunings…</div>
    } @else if (failed()) {
        <div class="preview-state" role="status">
            Could not load matched tunings.
            <button type="button" class="retry-button" (click)="load()">Retry</button>
        </div>
    } @else if (rows().length === 0) {
        <div class="preview-state" role="status">No matched tunings for this Pure Original.</div>
    } @else {
        <div class="preview-scroll" tabindex="0" aria-label="Matched tunings table">
            <table>
                <caption class="visually-hidden">Matched tunings for Pure Original {{ pureOriginalId }}, highest match rate first</caption>
                <colgroup>
                    <col class="matching-id-column"><col class="id-column"><col class="tuning-column"><col class="rate-column">
                    <col class="reference-column"><col class="date-column">
                </colgroup>
                <thead><tr>
                    <th scope="col">Matching ID</th>
                    <th scope="col">Version ID</th>
                    <th scope="col">Tuning</th>
                    <th scope="col" aria-sort="descending" title="Sorted by hitRate, highest first">Hit rate <i class="bi bi-arrow-down" aria-hidden="true"></i></th>
                    <th scope="col">WinOLS reference</th>
                    <th scope="col">Date uploaded</th>
                </tr></thead>
                <tbody>
                    @for (row of rows(); track row.pureOriginalMatchingDetailsId) {
                        <tr>
                            <td class="matching-id">
                                @if (isValidId(row.pureOriginalMatchingDetailsId)) {
                                    <a class="file-link" routerLink="/app/pure-originals/pure-original-details"
                                       [queryParams]="{pureOriginalId: pureOriginalId, matchingIds: row.pureOriginalMatchingDetailsId}"
                                       [attr.aria-label]="'Open matching ' + row.pureOriginalMatchingDetailsId + ' in Pure Original ' + pureOriginalId">{{ row.pureOriginalMatchingDetailsId }}</a>
                                } @else { — }
                            </td>
                            <td class="version-id">
                                @if (isValidId(row.versionId)) {
                                    <button class="file-link" type="button" (click)="openVersion(row.versionId)"
                                            [disabled]="openingVersionId() != null"
                                            [attr.aria-busy]="openingVersionId() === +row.versionId"
                                            [attr.aria-label]="'Open version ' + row.versionId + ' in its Master'">{{ row.versionId }}</button>
                                } @else { — }
                            </td>
                            <td class="tuning-name" [title]="row.tuningName || ''">{{ row.tuningName || '—' }}</td>
                            <td>
                                <span class="match-rate" [ngClass]="row.tone"
                                      [attr.title]="row.rate == null ? 'Hit rate unavailable' : 'Hit rate: ' + row.rate">
                                    <span class="percentage">{{ row.percentage == null ? '—' : (row.percentage | number:'1.0-2') + '%' }}</span>
                                </span>
                            </td>
                            <td class="reference" [title]="row.versionWinOLSReference || ''">{{ row.versionWinOLSReference || '—' }}</td>
                            <td class="date" [title]="row.dateUploaded || ''">{{ row.uploadedLabel }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (navigationError()) {
            <div class="navigation-error" role="alert">{{ navigationError() }}</div>
        }
    }
</section>
